import React, { useState } from 'react';
import moment from 'moment';
import CommentBox from '../../admin/parcel/components/comment';
import EditIcon from '@material-ui/icons/Edit';
import Check from '@material-ui/icons/Check';
import Cross from '@material-ui/icons/Clear';
import Call from '@material-ui/icons/Call';
import API from '../../../create/api';
import AddressTag from './table.mobile-table-row.address';
import { Checkbox } from '@mui/material';

export default function MobileTableRow({ row, index, refreshData, checkboxes, handleCheckBox }: any) {
  const [editCODBool, setEditCODBool] = useState(false);
  const [editStatusBool, setEditStatusBool] = useState(false);

  const [editCOD, setEditCOD] = useState(row?.merchant_COD);
  const [editStatus, setEditStatus] = useState(row?.status);

  function updateCOD() {
    return API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, row?.id, {
      collected_amount: editCOD,
      return_product_price: (row.merchant_COD ?? 0) - editCOD,
    }).finally(() => {
      refreshData();
      setEditCODBool(false);
    });
  }

  function CODDom(collectedAmount: number, merchantCOD: number) {
    return (
      <React.Fragment>
        {collectedAmount > 0 && collectedAmount !== merchantCOD ? (
          <span>
            <span className="line-through mr-1">{merchantCOD}</span>
            <span>{collectedAmount}</span>
          </span>
        ) : (
          row?.merchant_COD ?? 'N/A'
        )}

        {(editStatus === 'PARTIALLY_DELIVERED_BY_RIDER' || editStatus === 'DELIVERED_BY_RIDER') && (
          <span
            className="p-1 rounded-full hover:cursor-pointer ml-1"
            onClick={() => {
              setEditCODBool(true);
            }}
          >
            <EditIcon style={{ fontSize: '0.8rem' }} />
          </span>
        )}
      </React.Fragment>
    );
  }

  function EditCODDom() {
    return (
      <React.Fragment>
        <input
          className="w-full rounded p-1.5 relative mb-1"
          type="number"
          value={editCOD}
          onChange={(e) => setEditCOD(e.target.value || null)}
        />
        <span className="p-1 text-gray-100 font-bold absolute right-8">
          <Check className="bg-green-300 hover:cursor-pointer" onClick={() => updateCOD()} />
          <Cross className="bg-red-400 rounded-e hover:cursor-pointer" onClick={() => setEditCODBool(false)} />
        </span>
      </React.Fragment>
    );
  }

  function updateStatus() {
    return API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, row?.id, { status: editStatus }).finally(() => {
      refreshData();
      setEditStatusBool(false);
    });
  }

  function StatusDom() {
    return (
      <React.Fragment>
        {statusMapper(row?.status)}
        <span
          className="p-1 rounded-full hover:cursor-pointer ml-1"
          onClick={() => {
            setEditStatusBool(true);
          }}
        >
          <EditIcon style={{ fontSize: '0.8rem' }} />
        </span>
      </React.Fragment>
    );
  }

  function EditStatusDom() {
    return (
      <React.Fragment>
        <select
          className="w-full rounded p-1.5 mb-1"
          value={editStatus}
          onChange={(e) => setEditStatus(e.target.value)}
        >
          <option value="DELIVERED_BY_RIDER">Delivered</option>
          <option value="RETURNED_BY_RIDER">Returned</option>
          <option value="PARTIALLY_DELIVERED_BY_RIDER">Partial Del.</option>
          <option value="ON_DELIVERY">On Delivery</option>
        </select>
        <span className="p-1 text-gray-100 font-bold absolute right-2/4">
          <Check className="bg-green-300 hover:cursor-pointer" onClick={() => updateStatus()} />{' '}
          <Cross
            className="bg-red-400  hover:cursor-pointer"
            onClick={() => {
              setEditStatusBool(false);
              setEditStatus(row?.status);
            }}
          />
        </span>
      </React.Fragment>
    );
  }

  function statusMapper(status: string) {
    switch (status) {
      case 'DELIVERED_BY_RIDER':
        return 'Delivered';
      case 'RETURNED_BY_RIDER':
        return 'Returned';
      case 'ON_DELIVERY':
        return 'On Delivery';
      case 'PARTIALLY_DELIVERED_BY_RIDER':
        return 'Partial Delivered';
      default:
        return status;
    }
  }

  return (
    <div className="border-2 shadow-blue-100 shadow-lg rounded-md p-3 mb-3 bg-gray-300 grid grid-cols-3 gap-4">
      <div>
        <Checkbox
          size="small"
          name={`checkbox-${row.id}`}
          checked={checkboxes[`checkbox-${row.id}`] ?? false}
          onChange={(e) => {
            handleCheckBox(e, row.id);
          }}
          sx={{ padding: 0 }}
        />
        #{index + 1}{' '}
        <span className="text-gray-500 text-nowrap">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="15"
            height="15"
            fill="currentColor"
            className="inline-block"
          >
            <path d="M19 3h-1V2a1 1 0 0 0-2 0v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9h16v9zm0-11H4V6a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V5h6v1a1 1 0 0 0 2 0V5h2a1 1 0 0 1 1 1v1z" />
          </svg>
          {row.booking_date}
        </span>
      </div>
      <div>
        <span className="text-gray-500">APN: </span>
        {row?.id}
      </div>
      <div>
        <span className="text-gray-500">Invoice:</span> {row?.memoNo ?? 'N/A'}
      </div>
      <div>
        <span className="text-gray-500">Company: </span>
        {row?.company.name ?? 'N/A'}
      </div>
      <div>
        <span className="text-gray-500">Customer: </span>
        {row?.customerName ?? 'N/A'}
      </div>
      <div>
        <span className="text-gray-500">Phone: </span>
        <span className="font-bold whitespace-nowrap">
          <a href={`tel:${row?.phoneNumber}`}>
            <Call fontSize="inherit" />
            {row?.phoneNumber ?? 'N/A'}
          </a>
        </span>
      </div>
      <div className="col-span-3">
        <AddressTag row={row} refreshData={refreshData} />
      </div>
      {row?.details && (
        <div className="col-span-3">
          <span className="text-gray-500">Merchant Note: </span>
          {row?.details ?? ''}
        </div>
      )}
      <div className="col-span-3 grid grid-cols-2 ">
        <div>
          <div>
            <span className="text-gray-500">Status: </span>
          </div>
          {editStatusBool ? EditStatusDom() : StatusDom()}
        </div>
        <div className="">
          <div>
            <span className="text-gray-500">Merchant COD: </span>
          </div>
          <div>{editCODBool ? EditCODDom() : CODDom(row?.collected_amount, row?.merchant_COD)}</div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="text-gray-500 mb-1">Comments:</div>
        {row?.parcel_logs
          ?.filter((log: any) => log?.type === 'comment')
          .map((log: any) => (
            <div className="border-2 p-2 rounded-md my-1 bg-gray-100 border-primary-blue">
              <div>{log?.details}</div>
              <div className="text-gray-500 text-xs">
                {`${moment(log?.created_at).format('DD-MMM-YYYY')} \n ${moment(log?.created_at).format('hh:mm a')}`}
              </div>
            </div>
          ))}
        <div>
          <CommentBox
            parcel_id={row?.id}
            reload_parcel={async () => {
              await refreshData();
            }}
          />
        </div>
      </div>
    </div>
  );
}
